export default function generateStaticPage() {
  // On prerender use delay to fetch all childs data, on production fire it right a way
  const delay = (window as any).__PRERENDER_INJECTED ? 3000 : 0;
  setTimeout(() => {
    document.dispatchEvent(new Event('generate-static-page'));
  }, delay);
}
